import React from 'react';
import { Mail, Phone, Smartphone, MapPin } from 'lucide-react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import LeadForm from '@/components/LeadForm';
import { CONTACT } from '@/data/contact';

export default function Contact() {
  return (
    <div className="bg-[#0B0B0B] min-h-screen">
      <Navbar />
      <main className="max-w-[1000px] mx-auto px-6 lg:px-10 pt-36 pb-24">
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#3B82F6]">Contact</p>
        <h1 className="mt-4 font-display font-bold text-4xl lg:text-5xl text-white tracking-tight">
          Speak to an account lead
        </h1>
        <p className="mt-5 text-white/55 font-light leading-relaxed max-w-2xl">
          For bookings, talent representation and enterprise digital production enquiries, reach us
          directly or send a short brief — a senior account lead responds personally.
        </p>

        <div className="mt-12 grid lg:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div className="space-y-3">
              <a href={`mailto:${CONTACT.sales}`} className="flex items-center gap-3 text-white/75 hover:text-[#3B82F6] transition-colors">
                <Mail className="w-4 h-4" /> {CONTACT.sales}
              </a>
              <a href={`mailto:${CONTACT.bookings}`} className="flex items-center gap-3 text-white/75 hover:text-[#3B82F6] transition-colors">
                <Mail className="w-4 h-4" /> {CONTACT.bookings}
              </a>
              <a href={CONTACT.officePhoneHref} className="flex items-center gap-3 text-white/75 hover:text-[#3B82F6] transition-colors">
                <Phone className="w-4 h-4" /> {CONTACT.officePhone}
              </a>
              <a href={CONTACT.mobilePhoneHref} className="flex items-center gap-3 text-white/75 hover:text-[#3B82F6] transition-colors">
                <Smartphone className="w-4 h-4" /> {CONTACT.mobilePhone}
              </a>
            </div>

            <div className="grid sm:grid-cols-2 gap-6 pt-6 border-t border-white/10">
              {CONTACT.offices.map((o) => (
                <div key={o.label}>
                  <div className="flex items-center gap-2 mb-2.5">
                    <MapPin className="w-3.5 h-3.5 text-[#3B82F6]" />
                    <span className="text-[10px] uppercase tracking-[0.16em] text-white/45">{o.label}</span>
                  </div>
                  <address className="not-italic text-sm text-white/65 leading-relaxed">
                    {o.lines.join(', ')}
                  </address>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-7">
            <h2 className="font-display font-bold text-xl text-white tracking-tight">Send a brief</h2>
            <div className="mt-5">
              <LeadForm type="pitch_brand" showBusinessName showMessage showAdSpend={false} buttonLabel="Submit enquiry" />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}